import moment from 'moment';
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import MarketWbApi from '../../../API/market/wb-api';
import SuppliesApi from '../../../API/shipment/supplies-api';
import { Column, Row, WhiteBlock } from '../../../components/Basic/Blocks';
import { Button, CheckButton } from '../../../components/Basic/Buttons';
import { Content } from '../../../components/Basic/Global';
import { DateInput, InputLabel, Select } from '../../../components/Basic/Inputs';
import {
  MARKETS_MAP,
  TYPE_BUTTONS,
  WB_1,
  WB_2,
  WB_3,
  WB_4,
  WB_5,
  WB_6,
  WB_7
} from '../../../constans';
import WbTable from './Table';
import { Text } from '../../../components/Basic/WrapsStyle';

const WbStoragePage = () => {

  const user = useSelector((store) => store.user);
  // const shop = useSelector((store) => store.wb.market);

  const [shop, setShop] = useState('Все')
  const [filter, setFilter] = useState({})
  const [postingsLoadExcel, setPostingsLoadExcel] = useState(false)

  const [period, setPeriod] = useState({ start: moment().subtract(1, 'M').format('YYYY-MM-DD'), end: moment().format('YYYY-MM-DD') })

  const dispatch = useDispatch();

  const updateProviderStocks = async (providerId = undefined, isNullStock = false, offerIds = undefined) => {
    return await MarketWbApi.updateStocks({
      data: {
        shop: MARKETS_MAP[shop],
        filter: {
          providerId,
          offerIds,
        },
        rules: {
          nullProvider: isNullStock,
          nullWarehouse: isNullStock,
        },
      },
    });
  };

  const updateProviderPrice = async (providerId = undefined, offerIds = undefined, ignoreDiffPrice = undefined) => {
    return await MarketWbApi.updatePrices({
      data:
      {
        shop: MARKETS_MAP[shop],
        filter: {
          providerId,
          offerIds,
        },
        rules: {
          ignoreDiffPrice,
        },
        skladName: 'msk',
      }
    });
  };

  

  const isOwner = user.role === 'owner' || user.role === 'admin';

  return (
    <Content>
      <Row style={{ alignItems: 'stretch', margin: '10px 0' }}>
        <WhiteBlock
          // title="Управление"
          // title_bold={`Wildberries ${shop} (${WB_MARKET_IP[shop]})`}
          style={{ marginRight: '30px', minWidth: '600px' }}
          minimize={true}
        >
          <Row style={{ alignItems: 'stretch' }}>
            <Column>
              <Row style={{ marginBottom: '15px' }}>
                <Select
                  label="Магазин"
                  select={shop}
                  width="200px"
                  style={{ marginRight: '30px' }}
                  list={['Все', WB_1, WB_2, WB_3, WB_4, WB_5, WB_6, WB_7]}
                  onSelect={(v) => setShop(v)}
                />
                <Column style={{ marginRight: '10px' }}>
                  <InputLabel>Начало периода</InputLabel>
                  <Row style={{ width: '130px' }}>
                    <DateInput
                      value={period.start}
                      onChange={(v) => setPeriod({ ...period, start: new Date(v) })}
                    />
                  </Row>
                </Column>
                <Column style={{ marginRight: '10px' }}>
                  <InputLabel>Конец периода</InputLabel>
                  <Row style={{ width: '130px' }}>
                    <DateInput
                      value={period.end}
                      onChange={(v) => setPeriod({ ...period, end: new Date(v) })}
                    />
                  </Row>
                </Column>
              </Row>


              <Row style={{ marginTop: '10px' }}>
                <Button
                  type={TYPE_BUTTONS.BLUE}
                  onClick={() => SuppliesApi.excelStorageWb({ data: { ...filter, limit: undefined, page: undefined,  lookupPostings: postingsLoadExcel } })}
                  style={{ marginRight: '10px' }}
                >
                  Выгрузить таблицу
                </Button>

                <div style={{ marginLeft: '40px', fontSize: '30px', fontWeight: 'bold', color: '#000000be' }}> Количество дней: {moment(period.end).diff(moment(period.start), 'days') + 1}</div>
              </Row>
              <Row>
                <CheckButton small style={{ marginRight: '10px' }} checked={postingsLoadExcel} onSelect={(v) => setPostingsLoadExcel(v)} />
                <Text>учесть заказы</Text>
              </Row>

            </Column>

          </Row>
        </WhiteBlock>
      </Row>
      <WbTable shop={shop} setFilter={setFilter} updateProviderStocksAndPrice={updateProviderStocks} updateProviderPrice={updateProviderPrice} period={period} />
    </Content>
  );
};

export default WbStoragePage;
